(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/row.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/row.js');

'use strict';

svs.maltipset.models.Row = Backbone.Model.extend({
  initialize: function() {
    this.setInitialData();
    this.listenTo(this.get('coupon'), 'coupon:empty', this.unMarkAll, this);
    if (this.get('rowNo') === 1) {
      this.set('showInitClearBtn', true);
    }
  },

  setInitialData: function() {
    var numberOfSelectedMatches = 0;
    var matchList = this.get('coupon')
      .get('draw')
      .get('matchList');

    _.each(this.get('selectedMatchIndexes'), function(item, index) {
      if (item === 1) {
        numberOfSelectedMatches++;
        matchList.at(index).markChanged(true);
      }
    });

    this.set({
      active: this.get('rowNo') === 1,
      numberOfSelectedMatches: numberOfSelectedMatches,
      completeRow: this.getMatchesLeftToSelect(numberOfSelectedMatches) <= 0,
      hasSelectedMatches: numberOfSelectedMatches > 0
    });
  },
  getMatchesLeftToSelect: function(numberOfSelectedMatches) {
    if (this.get('system') === svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
      return (
        svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM -
          (numberOfSelectedMatches || this.get('numberOfSelectedMatches'))
      );
    } else if (
      this.get('system') === svs.maltipset.constants.SYSTEM.R_SYSTEM
    ) {
      return (
        svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_RSYSTEM_MIN -
          (numberOfSelectedMatches || this.get('numberOfSelectedMatches'))
      );
    } else if (
      this.get('system') === svs.maltipset.constants.SYSTEM.M_SYSTEM
    ) {
      return (
        svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_MSYSTEM_MIN -
          (numberOfSelectedMatches || this.get('numberOfSelectedMatches'))
      );
    }
  },
  markIndex: function(index, mark) {
    var isChange = this.get('selectedMatchIndexes')[index] == 1 != mark;
    if (isChange) {
      this.get('selectedMatchIndexes')[index] = mark ? 1 : 0;
      var numberOfSelectedMatches = this.get('numberOfSelectedMatches');

      if (mark) {
        numberOfSelectedMatches++;
      } else if (numberOfSelectedMatches > 0) {
        numberOfSelectedMatches--;
      }

      this.set({
        numberOfSelectedMatches: numberOfSelectedMatches,
        hasSelectedMatches: numberOfSelectedMatches > 0,
        completeRow:
            this.getMatchesLeftToSelect(numberOfSelectedMatches) <= 0,
        lastMatchChanged: {
          index: index,
          mark: mark
        }
      });
    }
  },
  getMatchesMaxLeftToSelect: function(numberOfSelectedMatches) {
    numberOfSelectedMatches =
        numberOfSelectedMatches || this.get('numberOfSelectedMatches');
    var matchesLeft;

    if (
      this.get('coupon').get('system') ===
        svs.maltipset.constants.SYSTEM.NO_SYSTEM
    ) {
      matchesLeft =
          svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM -
          numberOfSelectedMatches;
    } else {
      if (this.get('xpertBaseRowMode')) {
        matchesLeft =
            this.get('coupon').get('xpertSize') - numberOfSelectedMatches;
      } else {
        matchesLeft =
            svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_SYSTEM_MAX -
            numberOfSelectedMatches;
      }
    }

    return this.get('coupon').get('xpertBaseRowMode')
        ? matchesLeft - 1
        : matchesLeft;
  },
  isMaxNoOfMatchesSelected: function(numberOfSelectedMatches) {
    return this.getMatchesMaxLeftToSelect(numberOfSelectedMatches) <= 0;
  },
  unMarkAll: function() {
    var self = this;
    _.each(this.get('selectedMatchIndexes'), function(item, index) {
      self.markIndex(index, false);
    });
    this.trigger('unMarkAll');
  },
  defaults: function() {
    var emptyArray = [];

    for (var i = 0; i < svs.maltipset.constants.NUMBER_OF_MATCHES; i++) {
      emptyArray.push(0);
    }

    return {
      selectedMatchIndexes: emptyArray, 
      numberOfSelectedMatches: 0
    };
  }
});


 })(window);